export function buildSaleOrderHeaderPayload(budget: any, opportunity: any): any {
  return {
    id: budget.id,
    name: budget.name || '',
    driveUrl: budget.driveUrl || '',
    isActive: budget.isActive !== undefined ? budget.isActive : true,
    leadId: budget.leadId || opportunity?.id || opportunity?.originalId,
    teamId: budget.teamId || opportunity?.teamId,
    currencyId: budget.currencyId || 1,
    partnerId: budget.partnerId || null,
    expirationDate: budget.expirationDate
      ? typeof budget.expirationDate === 'string'
        ? budget.expirationDate
        : new Date(budget.expirationDate).toISOString()
      : null,
    budgetDate: budget.budgetDate
      ? typeof budget.budgetDate === 'string'
        ? budget.budgetDate
        : new Date(budget.budgetDate).toISOString()
      : null,
    budgetTemplateId: budget.budgetTemplateId || budget.budgetTemplate || null,
    priceListId: budget.priceListId || null,
    paymentConditionsId:
      budget.paymentConditionsId || budget.paymentConditions || null,
  };
}

export function isSuccessfulSaleOrderUpdate(response: any): boolean {
  return response?.success !== false;
}
